import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AddressBookService } from '../../data/address-book.service';
import { AppState } from '../index';
import { Store } from '@ngrx/store';
import {
    addressBooksTableAddAssist,
    addressBooksTableChangePage, addressBooksTableChangeQuery,
    addressBooksTableFailure, addressBooksTableRemoveAssist,
    addressBooksTableRequest, addressBooksTableSort,
    addressBooksTableSuccess
} from './address-books-table.actions';
import { catchError, map, mergeMap, tap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { selectAddressBooksTableQuery } from './address-books-table.state';
import { AddressBookFilterService } from '../../modules/shared/filter/address-book-filter.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class AddressBooksTableEffects {

    constructor(private actions$: Actions, private addressBookService: AddressBookService, private store: Store<AppState>,
                private snackbar: MatSnackBar, private addressBooksFilterService: AddressBookFilterService) {
    }

    addressBooksTableRequest$ = createEffect(() => this.actions$.pipe(
        ofType(addressBooksTableRequest),
        withLatestFrom(this.store.select(selectAddressBooksTableQuery)),
        mergeMap(([ , query ]) => this.addressBookService.query(query).pipe(
            map((result) => {
                return addressBooksTableSuccess({
                    totalCount: result['hydra:totalItems'],
                    page: result['hydra:member']
                });
            })
        )),
        catchError((e) => of(addressBooksTableFailure()))
    ));

    addressBooksTableFailure$ = createEffect(() => this.actions$.pipe(
        ofType(addressBooksTableFailure),
        tap(() => this.snackbar.open($localize`We are having difficulty communicating with the server.  Please try again later.`))
    ), { dispatch: false });

    addressBooksTableChangePage$ = createEffect(() => this.actions$.pipe(
        ofType(addressBooksTableChangePage),
        map(() => addressBooksTableRequest())
    ));

    addressBooksTableChangeSort$ = createEffect(() => this.actions$.pipe(
        ofType(addressBooksTableSort),
        map(() => addressBooksTableRequest())
    ));

    addressBooksTableChangeQuery$ = createEffect(() => this.actions$.pipe(
        ofType(addressBooksTableChangeQuery),
        map(() => addressBooksTableRequest())
    ));

    addressBooksTableFilterAdd$ = createEffect(() => this.actions$.pipe(
        ofType(addressBooksTableAddAssist),
        withLatestFrom(this.store.select(selectAddressBooksTableQuery)),
        map(([ action, query ]) => this.addressBooksFilterService.applyAssist(query, action.id, action.parameter)),
        map(query => addressBooksTableChangeQuery({ query }))
    ));

    addressBooksTableFilterRemove$ = createEffect(() => this.actions$.pipe(
        ofType(addressBooksTableRemoveAssist),
        withLatestFrom(this.store.select(selectAddressBooksTableQuery)),
        map(([ action, query ]) => this.addressBooksFilterService.removeAssist(query, action.id)),
        map(query => addressBooksTableChangeQuery({ query }))
    ));
}
